<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      rx="12"
      fill="url(#paint0_linear_2369_1756)"
    />
    <path
      d="M18 8L10.4809 16L6 11.2325"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2369_1756"
        x1="4"
        y1="3.5"
        x2="19"
        y2="22.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5BC88C" />
        <stop
          offset="1"
          stop-color="#1EA498"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
